import React from 'react';
import { useLocation } from 'react-router-dom';
import NotFoundPage from '../pages/NotFoundPage';

const AdminRoute: React.FC<{ userInfo: any; children: React.ReactNode }> = ({ userInfo, children }) => {
  if (!userInfo?.isAdmin) {
    return <NotFoundPage />;
  }
  return <>{children}</>;
};

export default AdminRoute;